module.exports = __webpack_public_path__ + "img/fwzc-03.79f1e17a.jpg";